<script>
    import Modal from "./Modal.svelte";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    const modalAction = () => {
        dispatch("modalAction")
    }
    export let modalStatus;
</script>

<Modal {modalStatus} on:modalAction={modalAction}>
    <form class="column-direction flex">
        <label>Enter the number of units to buy:</label>
        <input type="text" class="form-control">
        <button type="submit" class="submit-btn">Buy rTKN</button>
    </form>
</Modal>